import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import {MixpanelService} from "crqlar-react-common/dist/services/analytics/mixpanel.service";
import {useTrackScreenVisit} from "crqlar-react-common/dist/utils/analytics.util";
import {useNewsletterAccountQuery} from "crqlar-react-common/dist/utils/hooks/newsletter/useNewsletterAccount";
import {useReadOnly} from "crqlar-react-common/dist/utils/hooks/users/useReadOnly";
import {useTranslation} from "react-i18next";
import NewsletterSetup from "./NewsletterSetup";

const NewsletterDashboards = () => {
    useTrackScreenVisit("newsletter");

    const {t} = useTranslation();
    const readOnlyUser = useReadOnly();
    const newsletterAccountQuery = useNewsletterAccountQuery();
    const newsletterAccountAccess = newsletterAccountQuery.data;

    const handleOpenDashboard = () => {
        if (!newsletterAccountAccess?.newsletterAccountLoginUrl) return;

        MixpanelService.getInstance().track("go to newsletter account");
        window.open(
            `${newsletterAccountAccess.newsletterAccountLoginUrl}/eagle_kp_webapp/login/oidc_auth.msa`,
            "_blank",
            "noopener,noreferrer",
        );
    };

    if (newsletterAccountQuery.isLoading) {
        return (
            <Box sx={{flex: 1, minHeight: 600, display: "flex", alignItems: "center", justifyContent: "center"}}>
                <CircularProgress/>
            </Box>
        );
    }

    if (!newsletterAccountAccess?.newsletterAccountId) {
        return (
            <Box sx={{flex: 1, minHeight: 600, display: "flex", alignItems: "center", justifyContent: "center"}}>
                <NewsletterSetup/>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                flex: 1,
                minWidth: 0,
                minHeight: 600,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                px: 3,
                py: 9,
            }}
        >
            <MarkEmailReadOutlinedIcon sx={{fontSize: 48, color: "#9aa0ae", mb: 2.5}}/>

            <Typography variant="h6" sx={{fontWeight: 700, color: "text.primary", mb: 1}}>
                {t("Your newsletter account is ready")}
            </Typography>

            <Typography
                variant="body2"
                color="text.secondary"
                sx={{maxWidth: 380, mb: 3, lineHeight: 1.5}}
            >
                {t("To open your newsletter account, click on the button below")}
            </Typography>

            <Button
                variant="contained"
                disabled={readOnlyUser || !newsletterAccountAccess.newsletterAccountLoginUrl}
                onClick={handleOpenDashboard}
            >
                {t("GO TO NEWSLETTER ACCOUNT")}
            </Button>
        </Box>
    );
};

export default NewsletterDashboards;
